/**
 * Latori: hides the Trusted Shops badge while the visitor scrolls (desktop
 * only) and shows it again once scrolling has settled.
 *
 * The badge is a fixed container Trusted Shops injects at the very end of
 * <body> (`div[id^="trustbadge-container-"]`, int32-max z-index) - on the
 * collection page it covers the filter column, on the PDP the add-to-cart
 * area, and the widget itself has no "hide on scroll" option for desktop
 * (mobile collapses it on its own). So the page toggles a class on <html>
 * and snippets/custom-styles-latori.liquid fades the container out on that
 * class - the same technique the open search drawer already uses via the
 * .show-search body class.
 *
 * Nothing here touches the widget's DOM or config, so a Trusted Shops update
 * can't break it; at worst the badge simply stays visible.
 */
(function () {
  var HIDE_CLASS = 'trustbadge-hidden-latori';
  var SETTLE_MS = 1000;
  var desktop = window.matchMedia(
    (window.theme && theme.mediaQueries && theme.mediaQueries.md) || '(min-width: 768px)'
  );
  var timer = null;
  var root = document.documentElement;

  function onScroll() {
    if (!desktop.matches) return;
    root.classList.add(HIDE_CLASS);
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      root.classList.remove(HIDE_CLASS);
      timer = null;
    }, SETTLE_MS);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  desktop.addEventListener('change', function (evt) {
    if (!evt.matches) {
      root.classList.remove(HIDE_CLASS);
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }
  });
})();
